import { Box, Button, type SelectChangeEvent } from '@mui/material'
import { useState, useEffect } from 'react'
import { DatePickerWithLabel } from 'Components/DatePicker'
import { toast } from 'react-toastify'
import { sendGet, sendPost } from 'hooks/use-fetch'
import { SelectWithLabel, type SelectOption } from 'Components/SelectWithLabel'
import { type msdsPeriod } from 'Pages/CaregiverPortal/types'

export function ConsecutiveEnrollmentOptions (): JSX.Element {
  const [periods, setPeriods] = useState<msdsPeriod[]>([])
  const [selectedPeriod, setSelectedPeriod] = useState<number | null>(null)
  const [startDate, setStartDate] = useState<Date | null>(null)
  const [endDate, setEndDate] = useState<Date | null>(null)

  useEffect(() => {
    const fetchData = async (): Promise<void> => {
      const { response: response3 } = await sendGet('/Reporting/MSDSPeriods', {})
      setPeriods(response3)
    }

    void fetchData()
  }, [])

  const periodChange = (event: SelectChangeEvent<number | null>): void => {
    const periodId: number = parseInt(String(event.target.value?.toString()))
    const period = periods.find(p => p.periodID === periodId)
    if (period !== undefined) {
      setStartDate(period.startDate)
      setEndDate(period.endDate)
    }
    setSelectedPeriod(periodId)
  }

  const openReport = async (): Promise<void> => {
    if (startDate === null || endDate === null) {
      toast.error('Please enter required values.')
    } else {
      const { response, success } = await sendPost('/Reporting/ConsecutiveEnrollmentReportURL', { startDate, endDate })
      if (success) {
        window.open(response, '_blank')?.focus()
      }
    }
  }

  return <>
    <Box className='mt-10'>
      <SelectWithLabel
        width="250px"
        aria-labelledby="periodID"
        name="periodID"
        label="Period"
        options={periods.map((val, index) => {
          const item: SelectOption<number> = {
            id: val.periodID,
            name: val.periodName
          }
          return item
        })
        }
        value={selectedPeriod ?? undefined}
        onChange={periodChange}
      />

      <DatePickerWithLabel
        required={true}
        label='Count Date'
        name='startDate'
        onChange={setStartDate}
        value={startDate}
      />
      <DatePickerWithLabel
        required={true}
        label='Previous Date'
        name='endDate'
        onChange={setEndDate}
        value={endDate}
      />

    </Box>

    <Box className='mt-10'>
      <Button color='secondary' variant='contained' onClick={openReport}>Preview</Button>
    </Box>
  </>
}
